import React, { Component } from 'react';
import SidebarPresets from "components/sidebar/SidebarPresets.js";
import Resolution from "engine/Resolution.js";
import PianoRollContextDropdown from "components/pianoroll2/PianoRollContextDropdown.js"
import PianoRollScroll from '../pianoroll2/PianoRollScroll.js';
import PianoRollControl from '../pianoroll2/PianoRollControl.js';
import PianoRollPlayTick from '../pianoroll2/PianoRollPlayTick.js';
import NotesSidePanel from './NotesSidePanel.js';
import { connect } from "react-redux";
import ParameterAutomation from 'components/automation/ParameterAutomation.js';
import {DEFAULT_HEIGHT} from './constants.js';
import PianoRollSelection from './PianoRollSelection.js';
import NoteSidePanelRow from './NoteSidePanelRow.js';
import {ARRANGEMENT_VIEW} from 'constants/view-modes.js';
import {getStepFromPosition} from 'components/arrangement/getStepFromPosition.js';
import PianoRollCursor from './PianoRollCursor.js';
import Colors from 'components/Colors.js';
import {setSelectorMode} from 'actions/index.js';
import Track from 'track/Track.js';
import Notes from 'midi/Notes.js';
import {mouseDown} from 'actions/index.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import {setTrackFocused} from 'actions/index.js';
import {setTracksToResample} from 'actions/index.js';
import PianoRollTimeRow from 'components/pianoroll/PianoRollTimeRow.js';
import PianoRollRowComponent from 'components/pianoroll/PianoRollRowComponent.js';
import PianoRollToolbar from 'components/pianoroll/PianoRollToolbar.js';
import PaginationButtons from 'components/pianoroll/PaginationButtons.js';

import {hasNextPage} from 'components/pianoroll/PianoRollPagination.js';
import {hasPreviousPage} from 'components/pianoroll/PianoRollPagination.js';
import {getNextPageStart} from 'components/pianoroll/PianoRollPagination.js';
import {getNextPageEnd} from 'components/pianoroll/PianoRollPagination.js';
import {getPreviousPageStart} from 'components/pianoroll/PianoRollPagination.js';
import {getPreviousPageEnd} from 'components/pianoroll/PianoRollPagination.js';
import {getPagination} from 'components/pianoroll/PianoRollPagination.js';
import {getCurrentPage} from 'components/pianoroll/PianoRollPagination.js';
import {getTotalPages} from 'components/pianoroll/PianoRollPagination.js';
import {setSelectedPianoRollSteps} from 'actions/index.js';
import {setPianoRollNotes} from 'actions/index.js';
import {setPianoRollSelection} from 'actions/index.js';
import {setArrangementPatternDragging} from 'actions/index.js';
import {LEFT_SPACE} from './constants.js';
import {setStepsToCopy} from 'actions/index.js';
import {setEasyPatternToCopy} from 'actions/index.js';
import {setPianoRollCursor} from 'actions/index.js';
import {setSidebarViewMode} from 'actions/index.js';
import {SOUNDS} from 'constants/sidebar-view-modes.js';
import {deleteSteps} from 'operations/actions.js';
import '../../PianoRoll.scss';

const WIDTH = 36;
const MAX_TRANSPOSE = 92 ;
const MIN_TRANSPOSE = -36;
let keysDown = {};
let lastEvent = undefined;
const MIN_X_SCALE = 0.35;
const colors = new Colors();
const baseResolution = new Resolution(32,false);

let counter=0;

const SCROLL_CLASS_NAME = 'piano-roll-wrapper';

class PianoRollComponent extends Component {
    constructor(props) {
        super(props);
        this.lastDuration = React.createRef(undefined);
        this.contextContainerRef = React.createRef(undefined);
        this.state = {
            loading: false,
            notes: [],
            xScale: Math.max(MIN_X_SCALE, this.getMinXScale()),
        };

        this.ref = React.createRef();

        this.scale = props.scale || 0.5;
        this.note = this.getInitialNote(); 
        this.updateNotes();

        this.lastKeyDownEvent = undefined;

        this.operationManager = this.props.sequencerEngine.operationManager;

        this.onWheel = this.onWheel.bind(this);
    }

    getInitialNote(props=this.props) {
        let sum=0;
        let count=0;
        if (props.track.pattern === undefined) {
            return Notes.NOTES[0];
        }

        for (let i in props.pattern.stepBucketsMatrix) {
            let bucket = props.pattern.stepBucketsMatrix[i] ||
                props.pattern.stepBuckets[i];
            for (let j in bucket.steps) {
                let step = bucket.steps[j];
                sum+=step.transpose;
                count++;
            }
        }
        if (count === 0) {
            return Notes.NOTES[0];
        }
        let avg = Math.floor(sum / count);
        return Notes.fromTranspose(avg);
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.stepsLength < this.props.stepsLength) {
            this.state.xScale = Math.max(MIN_X_SCALE, this.getMinXScale(nextProps));
        }
        if (nextProps.mouseX !== undefined &&
            nextProps.mouseX !== this.props.mouseX) {
            this.updateCursorFromArrangement(nextProps);
        }
        if (nextProps.bottomHeight !== this.props.bottomHeight ||
            nextProps.track !== this.props.track ||
            (!nextProps.isPlayingMix && nextProps.pattern !== this.props.pattern) &&
           nextProps.track !== undefined) {
            this.noteIndex = undefined;
            this.note = this.getInitialNote(nextProps); 
            this.updateNotes(nextProps);
        }
        return true;
    }

    // intializes the notes to be shown, based on the average transpose of the
    // steps in the pattern
    // shows 30 notes in the piano row.
    // TODO: have a way of showing more that doesn't kill the CP
    updateNotes(props=this.props) {
        let notes = [];
        let index = this.noteIndex === undefined ?
            Math.round(this.getNumNotes(props) / 2) :
            Math.round(this.noteIndex / this.scale);

        // where does zoomedNote go?
        let zoomedNote = this.state.zoomedNote;
        let zoomedNoteIndex = Math.floor(this.state.zoomedNoteRatio * this.getNumNotes(props));
        
        if (!this.note) {
            this.note = this.getInitialNote(props);
        }

        let baseNote = zoomedNote === undefined ?
            this.note.addTranspose(index) :
            zoomedNote.addTranspose(zoomedNoteIndex);
        if (baseNote.getTranspose() >= MAX_TRANSPOSE ||
            baseNote.getTranspose() - this.getNumNotes(props) < MIN_TRANSPOSE) {
            baseNote = Notes.fromTranspose(MIN_TRANSPOSE + this.getNumNotes(props));
        }
        for (let i=0; i < this.getNumNotes(props); i++) {
            notes.push(baseNote.addTranspose(-1 * i));
        }

        this.props.setPianoRollNotes(notes);
    }

    componentDidMount() {
        this.ref.current.addEventListener("mousewheel", this.onWheel, {passive: false});

        if (this.props.mouseX !== undefined) {
            //let newCursor = this.updateCursorFromArrangement();
        }
        this.props.setPianoRollCursor(undefined);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.xScale !== prevState.xScale && this.state.zoomStep !== undefined) {
            // then we zoom into the step
            let step = this.state.zoomStep;
            let x = step * WIDTH * this.state.xScale;
            this.ref.current.scroll(x - this.state.zoomOffset, 0);
        }
    }

    updateCursorFromArrangement(props=this.props) {
        return;
        let state = this.props.sequencerEngine.store.getState();
        let newCursor = getStepFromPosition(
            props.mouseX,
            props.resolution,
            undefined,
            state.arrangement.xScale) / 2;

        if (props.track.pattern.startStep !== undefined) {
            newCursor -= props.resolution.transformStepAtResolution2(
                props.track.pattern.startStep, Track.baseResolution);
        }
        
        if (newCursor >= props.pattern.length() / 2 || newCursor < 0) {
            return;
        }
        this.props.setPianoRollCursor(newCursor === 0 ? undefined : newCursor);

        let x = LEFT_SPACE - 1 + newCursor * WIDTH * this.state.xScale;
        let el = document
            .getElementsByClassName(SCROLL_CLASS_NAME)[0];
        el.scrollLeft = x - 200;

        return newCursor;
    }

    componentWillUnmount() {
        this.ref.current.removeEventListener("mousewheel", this.onWheel);
        
        this.props.setSelectedPianoRollSteps(undefined);
        this.props.setPianoRollCursor(undefined);
        this.props.track.getEasyPattern().update();
    }

    getNumNotes(props=this.props) {
        let ratio  = 17 * props.bottomHeight / 560;
        return Math.max(Math.ceil(ratio / this.scale), 1);
    }

    onMouseDown(e, note, i) {
        this.mouseDown = true;
        this.dragStartY = e.pageY;
        if (this.dragStartX === undefined) {
            this.dragStartX = e.pageX;
        }

        this.setState({zoomedNote: note, zoomedNoteRatio: i / this.getNumNotes()});
    }

    onMouseUp(e) {
        this.mouseDown = false;
        this.dragStartX = undefined;
    }

    scrollVertically(transposeDiff) {
        let transpose = this.props.notes[0].getTranspose();
        let lastTranspose = this.props.notes[this.props.notes.length - 1].getTranspose();
        
        if (lastTranspose + transposeDiff < MIN_TRANSPOSE) {
            // don't let the user scroll past C0
            return;
        } else if (transpose + transposeDiff > MAX_TRANSPOSE) {
            // don't let the user scroll past C10
            return;
        }
        let notes = this.props.notes.map(
            note => note.addTranspose(transposeDiff));
        this.note = this.props.notes[0];
        this.props.setPianoRollNotes(notes);
    }


    onWrapperMouseMove(e) {
        this.mouseXPosition = e.clientX - this.ref.current.offsetLeft;
        this.mouseYPosition = e.clientY - this.ref.current.offsetTop;
        let noteIndex = Math.round((this.mouseYPosition - 40) / (DEFAULT_HEIGHT * this.scale));
        this.note = this.props.notes[noteIndex % this.props.notes.length];
        this.noteIndex = Math.floor(noteIndex / 2);
    }

    onMouseMove(e) {
        if (this.mouseDown) {
            this.dragY = e.pageY;

            let yDiff = this.dragY - this.dragStartY;
            let transposeDiff = Math.floor((yDiff / this.scale) / 60.0);

            if (Math.abs(transposeDiff) >= 1) {
                this.scrollVertically(transposeDiff);
            }

            let diff = e.pageX - this.dragStartX;
            if (Math.abs(diff) <= 2) {
                return;
            }
            this.scale += diff / 50.0;
            if (this.scale <= 0.4) {
                this.scale = 0.4;
            }

            if (this.scale >= 2) {
                this.scale = 2;
            }

            this.updateNotes();
        }
    }

    onMouseLeave(e) {
        this.props.mouseDown(false);
        this.mouseDown = false;
        clearInterval(this.octaveTimer);

        let state = this.props.sequencerEngine.store.getState();
        if (state.keyboard.pianoRollSelection !== undefined) {
            let selectedSteps = this.props.track.getEasyPattern()
                .getSelectedPianoRollSteps(
                    state.keyboard.pianoRollSelection,
                    this.props.resolution);

            this.props.setSelectedPianoRollSteps(selectedSteps);
            this.props.setPianoRollSelection(undefined);
        }
    }

    onWheel(e) {
        if (!this.mouseOverPianoRoll) {
            return;
        }
        if (e.ctrlKey) {
            e.preventDefault();
            e.stopPropagation();
            
            if (this.scrollCursor === undefined) {
                // set the cursor based on mouseXPosition
                this.scrollCursor = (this.ref.current.scrollLeft + this.mouseXPosition) / (WIDTH * this.state.xScale);
            }

            let _counter = ++counter;
            setTimeout(() => {
                if (_counter === counter) {
                    this.scrollCursor = undefined;
                }
            }, 250);

            // Your zoom/scale factor
            let xScale = this.state.xScale - e.deltaY * 0.03;
            let minXScale = Math.max(MIN_X_SCALE, this.getMinXScale());
            if (xScale <= minXScale) {
                xScale = minXScale;
            }
            this.setState({xScale: xScale});
            let width = this.scrollCursor * WIDTH * xScale;
            let scrollTo = width - this.mouseXPosition;
            this.ref.current.scrollTo(scrollTo, 0);
        } else {
            if (Math.abs(e.wheelDeltaY) <= 3 || Math.abs(e.wheelDeltaX) >= 12) { 
                // we dont need to scroll vertically because we are scrolling horizontally
                return false;
            }

            let transposeDiff = (e.wheelDeltaY / this.scale) / 20.0;
            if (transposeDiff < 0) {
                transposeDiff = Math.ceil(transposeDiff);
            } else {
                transposeDiff = Math.floor(transposeDiff);
            }

            if (transposeDiff !== 0) {
                e.preventDefault();
                e.stopPropagation();
            }
            this.scrollVertically(transposeDiff);
        }

        return false;
    }

    getMinXScale(props=this.props) {
        let scale = (window.innerWidth - 58 - 240) / (props.stepsLength * WIDTH);
        return Math.max(MIN_X_SCALE, scale);
    }

    setMinXScale() {
        this.setState({xScale: this.getMinXScale()});
        this.props.setPianoRollCursor(undefined);
    }

    get maxScale() {
        return 6;
    }

    zoomHorizontally(diff, step, offset) {
        let xScale = this.state.xScale + diff / 50;
        if (xScale < this.getMinXScale() || xScale > this.maxScale) {
            return;
        }
        this.setState({
            xScale: xScale,
            zoomStep: step,
            zoomOffset: offset,
        });
    }

    onMouseOverNote(note, noteIndex) {
        if (this.mouseDown) {
            return;
        }
        this.note = note;
        this.noteIndex = noteIndex;
    }

    onChangeLength() {
        this.setState({
            xScale: this.minXScale
        });
    }

    onMouseOverPianoRoll(mouseOver) {
        this.mouseOverPianoRoll = mouseOver;
    }

    onContextMenu(e) {
        let rect = this.contextContainerRef.current.getBoundingClientRect();
        e.preventDefault();
        let x = e.clientX - rect.left + 4;
        let y = e.clientY - rect.top;
        if (x - this.ref.current.scrollLeft >= window.innerWidth - 500) {
            x = this.ref.current.scrollLeft + window.innerWidth - 500;
        }
        if (y > window.innerHeight - 400) {
            y = window.innerHeight - 400;
        }
        this.setState({dropdownPos: {x,y}});
    }

    render() {
        if (this.props.track.pattern === undefined) {
            return (
                <div></div>
            );
        }
        let height = DEFAULT_HEIGHT * this.props.scale;
        let style = {
            height: this.props.bottomHeight - 71 - 90 // (piano roll control has 90 height)
        };

        const color=colors.getColorForTrack(this.props.track);
        let wholeWrapperClassName = this.props.showAutomation ?
            "whole-wrapper showing-automation" : "whole-wrapper";

         return (
            <div
              draggable={false}
              className="piano-roll-container">
              <ConditionedComponent condition={!this.props.hideToolbar}>
                <PianoRollToolbar
                  sequencerEngine={this.props.sequencerEngine} track={this.props.track}/>
              </ConditionedComponent>
             <div className="clear-fix"/>
              <div className="piano-horizontal">
              <div className="piano-column">
              <PianoRollScroll
                color={color}
                xScale={this.state.xScale}
                scroll={this.ref}
                track={this.props.track}/>
             <div
               style={style}
               onMouseMove={(e) => this.onWrapperMouseMove(e)}
               onMouseOver={(e) => this.onMouseOverPianoRoll(true)}
               onMouseLeave={(e) => this.onMouseOverPianoRoll(false)}
               className={wholeWrapperClassName}>
               <NotesSidePanel
                 setScale={(scale) => {
                     this.scale = scale;
                     this.updateNotes();
                 }}
                 scale={this.scale}
                 onMouseOver={(note, i) => this.onMouseOverNote(note, i)}
                 color={color}
                 setSelectedPianoRollSteps={this.props.setSelectedPianoRollSteps}
                 onMouseDown={(e, note, i) => this.onMouseDown(e, note, i)}
                 onMouseUp={(e) => this.onMouseUp(e)}
                 onMouseMove={(e) => this.onMouseMove(e)}
                 notes={this.props.notes}
                 track={this.props.track}
               />
              <div
                draggable={false}
                onMouseUp={() => this.onMouseUp()}
                onMouseLeave={() => this.onMouseLeave()}
                ref={this.ref}
                className="piano-roll-wrapper">
                <PianoRollTimeRow
                  setMinXScale={() => this.setMinXScale()}
                  height={this.props.bottomHeight}
                  color={colors.saturate(color, 0.4)}
                  isLooping={this.props.isLooping}
                  wrapperRef={this.ref}
                  zoomHorizontally={(diff, zoomStep, offset) => this.zoomHorizontally(diff, zoomStep, offset)}
                  xScale={this.state.xScale}
                  resolution={this.props.resolution}
                  track={this.props.track}
                  sequencerEngine={this.props.sequencerEngine}
                  />
                <PianoRollPlayTick
                  sequencerEngine={this.props.sequencerEngine}
                  track={this.props.track}
                  height={this.props.bottomHeight - 20}
                  xScale={this.state.xScale}
                  scale={this.scale}
                  />
                <PianoRollCursor
                  height={this.props.bottomHeight - 20}
                  xScale={this.state.xScale}
                  scale={this.scale}
                  />
                
                <PianoRollSelection
                  xScale={this.state.xScale}
                  scale={this.scale}
                  />
                <div
                  ref={this.contextContainerRef}
                  onContextMenu={(e) => this.onContextMenu(e)}
                  className={this.state.dropdownPos ? "masking piano-roll-rows-container" : "piano-roll-rows-container"}>
                  <PianoRollContextDropdown
                    xScale={this.state.xScale}
                    track={this.props.track}
                    clear={() => this.setState({dropdownPos: undefined})}
                    dropdownPos={this.state.dropdownPos}/>
                  {this.props.notes.map(
                      (note, i) =>
                          <PianoRollRowComponent
                            xScale={this.state.xScale}
                            lastDuration={this.lastDuration}
                            key={'note-' + i}
                            noteIndex={i}
                            color={color}
                            scale={this.scale}
                            parentClassName={SCROLL_CLASS_NAME}
                            onMouseOver={(note) => this.onMouseOverNote(note, i)}
                            resolution={this.props.resolution}
                            onMouseDown={(e) => this.onMouseDown(e, note, i)}
                            onMouseUp={(e) => this.onMouseUp(e)}
                            onMouseMove={(e) => this.onMouseMove(e)}
                            pattern={this.props.pattern}
                            sequencerEngine={this.props.sequencerEngine}
                            track={this.props.track}
                            note={note}
                          />)}
                </div>
            {this.props.showAutomation && this.ref.current ?
              <ParameterAutomation
                wrapperRef={this.ref}
                color={color}
                sequencerEngine={this.props.sequencerEngine}
                xScale={this.state.xScale}
                track={this.props.track}
              /> : ""}
             </div>
             </div>
              <PianoRollControl
                resolution={this.props.resolution}
                color={color}
                sequencerEngine={this.props.sequencerEngine}
                xScale={this.state.xScale}
                scroll={this.ref}
                track={this.props.track}/>
              </div>
                <SidebarPresets isPianoRoll={true} sequencerEngine={this.props.sequencerEngine}/>
              </div>
           </div>
        );
/* <PianoRollControl
                     resolution={this.props.resolution}
                     track={this.props.track}
                     xScale={this.state.xScale}
                     sequencerEngine={this.props.sequencerEngine}/> */
    }
}

const mapStateToProps = (state, props) => {
    let steps = props.track === undefined ? undefined :
        state.tracks.trackSteps[
        props.track.subSequence.isTrack ?
            props.track.subSequence.id : props.track.id];
    
    let track = props.track;
    if (track && track.tracks && track.tracks[0]) {
        track = track.tracks[0].track;
    }

    return {
        id: track === undefined ? 0 :
            track.sample !== undefined && track.sample.getId() !== undefined ?
            track.sample.getId() : track.presetName || track.getName(),
        samplers: track && track.instrument && track.instrument.samplers,
        stepsLength: steps === undefined ? 16 : steps.length,
        resolution: state.sequencer.displayResolution,
        tracksToResample: state.tracks.tracksToResample,
        notes: state.keyboard.notes,
        mouseX: state.arrangement.mouseX,
        bottomHeight: state.sequencer.viewMode !== ARRANGEMENT_VIEW &&
            !props.installation ? 550 : state.arrangement.bottomHeight,
        pattern: props.track ? props.pattern || props.track.pattern : undefined,
        isPlayingMix: state.mix.isPlayingMix,
        showAutomation: state.automation.show,
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        mouseDown: m => dispatch(mouseDown(m)),
        setTrackFocused: (trackNumber) => dispatch(setTrackFocused(trackNumber)),
        setSelectedPianoRollSteps: (steps) => dispatch(setSelectedPianoRollSteps(steps)),
        setPianoRollSelection: (a,b,c,d) => dispatch(setPianoRollSelection(a,b,c,d)),
        setStepsToCopy: (steps) => dispatch(setStepsToCopy(steps)),
        setEasyPatternToCopy: (easyPattern) => dispatch(setEasyPatternToCopy(easyPattern)),
        setTracksToResample: (tracks) => dispatch(setTracksToResample(tracks)),
        setPianoRollNotes: (notes) => dispatch(setPianoRollNotes(notes)),
        setPianoRollCursor: (cursor) => dispatch(setPianoRollCursor(cursor)),
        setSelectorMode: m => dispatch(setSelectorMode(m)),
        setSidebarViewMode: m => dispatch(setSidebarViewMode(m)),
        setArrangementPatternDragging: m => dispatch(setArrangementPatternDragging(m)),
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(PianoRollComponent);
